import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const BrandingContext = createContext({ app_name: 'Krris OS', app_tagline: '', primary_color: '#006080' });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({
    app_name: 'Krris OS',
    app_tagline: 'Your agency on autopilot.',
    primary_color: '#006080',
  });

  useEffect(() => {
    const api = `${process.env.REACT_APP_BACKEND_URL}/api/settings/public/branding`;
    axios.get(api)
      .then(r => setBranding(r.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    // Apply primary color to CSS variable so all components with var(--primary) update
    document.documentElement.style.setProperty('--primary', branding.primary_color);
    document.title = branding.app_name;
  }, [branding.primary_color, branding.app_name]);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext);
